import { SortMethod } from '@updater/ui-widgets';

export enum SortPill {
  Recommended = 'recommended',
  Speed = 'speed',
  BestValue = 'best_value',
  Price = 'price',
}

export const SORT_PILL_LABELS: Record<SortPill, string> = {
  [SortPill.Recommended]: 'Recommended',
  [SortPill.Speed]: 'Speed',
  [SortPill.BestValue]: 'Best value',
  [SortPill.Price]: 'Price',
};

export const SORT_PILL_SECTION_TITLES: Record<SortPill, string> = {
  [SortPill.Recommended]: 'Recommended for you',
  [SortPill.Speed]: 'Fastest plans first',
  [SortPill.BestValue]: 'Most speed per dollar',
  [SortPill.Price]: 'Lowest price first',
};

/**
 * The Recommended title when there are no quiz answers (the quiz was skipped):
 * the showcase isn't personalized then, so "Recommended for you" would
 * overstate it (COREX-2179).
 */
export const SKIPPED_QUIZ_RECOMMENDED_TITLE = 'Popular plans at your address';

export const PILL_TO_SORT_METHOD: Record<SortPill, SortMethod> = {
  [SortPill.Recommended]: SortMethod.BestForYou,
  [SortPill.Speed]: SortMethod.SpeedHighToLow,
  [SortPill.BestValue]: SortMethod.BestValue,
  [SortPill.Price]: SortMethod.PriceLowToHigh,
};
